import { CandidateCardComponent } from "./candidate-card.component";
export var CandidateCardModule = angular
    .module('candidateCard', [])
    .component(CandidateCardComponent.selector, CandidateCardComponent.component)
    .name;
//# sourceMappingURL=candidate-card.module.js.map